import { Skeleton } from '@src/components/base/Skeleton';
import { Suspense, lazy } from 'react';
import { generateJobWizardUrl } from '@src/paths';
import { useNavigate } from 'react-router-dom';
import Dialog from '@src/components/modals/Dialog';

export const JobImportModal = ({
  open = false,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const navigate = useNavigate();

  const LoadingSkeletons = () => (
    <div className="flex flex-col gap-4 h-full justify-center">
      <Skeleton as="h4" className="w-full" />
      <Skeleton className="h-20 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-30 w-full" />
      <Skeleton className="h-8 w-full" />
    </div>
  );
  let onDismissCallback: () => void | undefined;

  return (
    <Dialog
      data-testid="job-import-modal"
      title=""
      open={open}
      setOpen={(newOpen) => {
        if (!newOpen) {
          onDismissCallback();
        }
        setOpen(newOpen);
      }}
      actions={[]}
      dismissible={true}
      passthrough={{
        panel: { className: 'w-262.5 lg:min-h-170' },
      }}
    >
      <Suspense fallback={<LoadingSkeletons />}>
        <JobImportForm
          onImportDone={(jobId) => {
            navigate(generateJobWizardUrl(jobId) + location.search, {
              replace: true,
            });
            setOpen(false);
          }}
          onImportCanceled={() => setOpen(false)}
          onDismiss={(callback) => {
            onDismissCallback = callback;
          }}
        ></JobImportForm>
      </Suspense>
    </Dialog>
  );
};

const JobImportForm = lazy(() =>
  import('../import/JobImportForm').then((result) => ({
    default: result.JobImportForm,
  })),
);
